import {
  FETCH_TARIFA_ENVIO_PORTES,
  GET_TARIFA_ENVIO_PORTES,
  UPDATE_STATUS_PORTES,
} from '../actions/types.js'

const initialState = {
  tarifa: {},
  aceptado: false,
  isLoading: false,
}

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case GET_TARIFA_ENVIO_PORTES:
      return {
        ...state,
        tarifa: action.payload,
        aceptado: false,
        isLoading: false,
      }
    case FETCH_TARIFA_ENVIO_PORTES:
      return {
        ...state,
        tarifa: {},
        aceptado: false,
        isLoading: true,
      }
    case UPDATE_STATUS_PORTES:
      console.log('Actualizando estado con:', action.payload)
      return {
        ...state,
        aceptado: action.payload,
        isLoading: false,
      }
    default:
      return state
  }
}
